import * as React from 'react'

const TableTitle = ({ title }: { title: string }) => {
  //   const { t } = useLocalize()
  return (
    <div className="tw-flex tw-h-11 tw-w-full tw-items-end tw-justify-between tw-pb-3">
      <div className="tw-pr-4 tw-text-sm tw-font-medium tw-uppercase tw-text-content-base">
        {/* {t(title)} neet to be uncomment whent translation is enabled */}
        {title}
      </div>
    </div>
  )
}

export default TableTitle
